import { readPricingDetail } from './read-pricing-detail';

export const sharedOffersFields = {
    pricingDetail: {
        read: readPricingDetail,
    },
};
